import {listMedicineDecoction} from '@/api';

const DECOCTION_DICT_TYPE = 'medicine_decoct_way';
let decoctionNameMap = {};

export function loadDecoctionNameMap() {
    return listMedicineDecoction(DECOCTION_DICT_TYPE).then(response => {
        const rows = response && response.data && response.data.code === 200
            ? response.data.data
            : [];
        return rows.reduce((map, item) => {
            if (item && item.dictValue !== null && item.dictValue !== undefined) {
                map[String(item.dictValue)] = item.dictLabel || '';
            }
            return map;
        }, {});
    });
}

export function refreshDecoctionNameMap() {
    return loadDecoctionNameMap().then(map => {
        decoctionNameMap = map;
        return map;
    });
}

export function getDecoctionName(decoctWay, nameMap) {
    if (decoctWay === null || decoctWay === undefined || decoctWay === '') {
        return '';
    }
    const key = String(decoctWay);
    const activeMap = nameMap || decoctionNameMap;
    return activeMap && Object.prototype.hasOwnProperty.call(activeMap, key)
        ? activeMap[key]
        : '';
}
